import request from "../../utils/request";

export function getAllMessageLogs(params) {
  return request("/message-logs", {
    method: "GET",
    params,
  });
}
